import { getTheme, Spinner, Stack, Text } from "@fluentui/react";
import { strings } from "../../../localization/strings";
import { IPiceaOnlineApiSettings } from "../../../core/store/typings/IPiceaOnlineApiSettings";
import { useDispatch } from "react-redux";
import { actionCreators } from "../../../core/actions/settings-actions";
import { ParameterItem } from "../../../components/shared/configurator/components/ParameterItem";

type TProps = {
    data?: IPiceaOnlineApiSettings
    isUpdating: boolean
}

export const SettingsSecurityPiceaOnlineApiTab: React.FC<TProps> = props => {
    const dispatch = useDispatch();

    return (<>
        <Stack verticalFill>
            <Stack tokens={{ padding: 24, childrenGap: 16 }}>
                <Stack.Item>
                    <Stack horizontal>
                        <Stack style={{ width: 360 }} verticalFill tokens={{ childrenGap: 16 }} >
                            <Stack tokens={{ childrenGap: 16 }} >
                                <Stack.Item>
                                    <Text style={{ color: theme.palette.black, fontSize: 28, fontWeight: "bold", letterSpacing: "-.04em" }}>{strings.SETTINGS.SECURITY.PICEASOFT.PICEAONLINEAPI_TITLE}</Text>
                                </Stack.Item>
                            </Stack>
                        </Stack>
                    </Stack>
                </Stack.Item>
            </Stack>
            <Stack tokens={{padding: "0px 0px 0px 1rem"}}>
                <ParameterItem
                    noSeparator
                    useToggle
                    toggleEnabled={!props.isUpdating}
                    toggleChecked={props.data?.transactions}
                    toggleOnChange={() => dispatch(actionCreators.updateOgranizationPiceaonlineApiSettings({...props.data, transactions: !props.data?.transactions}))}
                    title={strings.SETTINGS.SECURITY.PICEAONLINEAPI.TRANSACTIONS_TITLE}
                    description={strings.SETTINGS.SECURITY.PICEAONLINEAPI.TRANSACTIONS_DESCRIPTION}
                />
                <ParameterItem
                    useToggle
                    toggleEnabled={!props.isUpdating}
                    toggleChecked={props.data?.accounts}
                    toggleOnChange={() => dispatch(actionCreators.updateOgranizationPiceaonlineApiSettings({...props.data, accounts: !props.data?.accounts}))}
                    title={strings.SETTINGS.SECURITY.PICEAONLINEAPI.ACCOUNTS_TITLE}
                    description={strings.SETTINGS.SECURITY.PICEAONLINEAPI.ACCOUNTS_DESCRIPTION}
                />
                <ParameterItem
                    useToggle
                    toggleEnabled={!props.isUpdating}
                    toggleChecked={props.data?.devices}
                    toggleOnChange={() => dispatch(actionCreators.updateOgranizationPiceaonlineApiSettings({...props.data, devices: !props.data?.devices}))}
                    title={strings.SETTINGS.SECURITY.PICEAONLINEAPI.DEVICES_TITLE}
                    description={strings.SETTINGS.SECURITY.PICEAONLINEAPI.DEVICES_DESCRIPTION}
                />  
            </Stack>
        </Stack>
    </>)
}

const theme = getTheme();